import React from 'react';
import { Alert } from './Alert';
import { Button } from './Button';

interface ErrorMessageProps {
  message: string;
  title?: string;
  onRetry?: () => void;
  className?: string;
}

export const ErrorMessage: React.FC<ErrorMessageProps> = ({
  message,
  title = 'Error',
  onRetry,
  className = '',
}) => {
  return (
    <Alert variant="error" title={title} className={className}>
      <p>{message}</p>
      {onRetry && (
        <div className="mt-3">
          <Button
            variant="danger"
            size="sm"
            onClick={onRetry}
          >
            Try Again
          </Button>
        </div>
      )}
    </Alert>
  );
};
